import type { FunctionComponent } from 'react';
import { Inline } from '@atlaskit/primitives';
import { cssMap } from '@atlaskit/css';
import ChangesIcon from '@atlaskit/icon/core/changes';

import Logo from './Logo';
import AtlassianUserIcon from './AtlassianUserIcon';

const styles = cssMap({
  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    // @ts-expect-error cssMap types do not allow nested element selectors, but
    // this is needed to size the generated ADS icon SVG to 24x24.
    '& svg': {
      width: '24px',
      height: '24px',
    },
  },
});

const AppLogos: FunctionComponent = () => {
  return (
    <Inline alignBlock="center" alignInline="center" space={'space.200'}>
      <Logo />
      <span css={styles.iconWrapper}>
        <ChangesIcon label="" />
      </span>
      <AtlassianUserIcon />
    </Inline>
  );
};

export default AppLogos;
